// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";

const uri = "api/custom/accountSettingRequestUpdate/emailForm";

export interface RequestUpdateAddressModel {
    acctNumber: string;
    customerName: string;
    jobName: string;
    jobAddress: string;
    jobCity: string;
    jobState: string;
    jobZip: string;
    jointCheckAgreement?: boolean;
    checkAppropriateStatement?: string;
    jobNumber?: string;
    defaultPoNumber?: string;
    jobForemen?: string;
    projectManagerAddress?: string;
    projectManagerTelephone?: string;
    projectManagerEmail?: string;
    projectManager?: string;
    generalContractorAddress?: string;
    generalContractorTelephone?: string;
    generalContractorEmail?: string;
    generalContractor?: string;
    ownerAddress?: string;
    ownerTelephone?: string;
    ownerEmail?: string;
    owner?: string;
    address?: string;
    telephone?: string;
    email?: string;
    bondedJob?: boolean;
    bondingCompanyName?: string;
    bondingCompanyPhone?: string;
    additionalInformation?: string;
}

export function requestUpdateAddress(parameter: RequestUpdateAddressModel) {
    return post<any>(uri, parameter);
}
